import { t } from '@lingui/macro';
import axios from 'axios';
import { addMessage } from 'components/ui/Messages';

const s3Axios = axios.create();

const uploadS3 = (api, attachment, file, data, options) => {
  s3Axios.put(data.url, file, { headers: { 'Content-Type': file.type } }).then(s3res => {
    if (options.onUpload) options.onUpload(s3res.data);
    axios.put(`/${api}/${attachment.pk}`, {
      file: data.file
    }).then(res => {
      if (options.onEditUpload) options.onEditUpload(res.data);
    }).catch(err => {
      if (options.onError) options.onError(err);
      addMessage(
        'update-attachment-failed',
        t`Unknown error`,
        t`Impossible to update attachment.`,
      );
    });
  }).catch(err => {
    axios.delete(`/${api}/${attachment.pk}`).catch(() => {
      addMessage(
        'update-attachment-failed',
        t`Unknown error`,
        t`Impossible to delete attachment.`,
      );
    });
    if (options.onError) options.onError(err);
    addMessage(
      's3-post-failed',
      t`Unknown error`,
      t`Impossible to upload file.`,
    );
  });
};

const loadFile = (api, attachment, file, options) => {
  axios.get(
    `/${api}/${attachment.pk}` +
    `/file/upload-url/${encodeURIComponent(file.name)}` +
    `?content-type=${encodeURIComponent(file.type)}`
  ).then(res => {
    uploadS3(api, attachment, file, res.data, options);
  }).catch(err => {
    if (options.onError) options.onError(err);
    addMessage(
      'get-upload-url-failed',
      t`Unknown error`,
      t`Impossible to get upload URL.`,
    );
  });
};

const uploadFile = (api, file, settings) => {
  const options = {
    onCreateUpload: null,
    onUpload: null,
    onEditUpload: null,
    onError: null,
    data: {},
    ...settings
  };
  axios.post('/' + api, options.data).then(res => {
    if (options.onCreateUpload) options.onCreateUpload(res.data);
    loadFile(api, res.data, file, options);
  }).catch(err => {
    if (options.onError) options.onError(err);
    addMessage(
      'create-attachment-failed',
      t`Unknown error`,
      t`Impossible to create attachment.`,
    );
  });
};

export default uploadFile;
